
import HTml from '../assent/html.png';
import Css from '../assent/css.png';
import Javascript from '../assent/javajscript.jpg';
import Bootstrap from '../assent/bed30ddfa5d434e827c775ac9a3b0d38.png';
import Reacts from '../assent/React_logo_PNG_(16).png';
import Mterial from '../assent/material.png';
import PHP from '../assent/php.png';
import MySQL from '../assent/mysql.png';
import Wordpress from '../assent/word press.png';
import Photoshop from '../assent/photoshop.jpg';
import Figma from '../assent/figma.png';
import Premiere from '../assent/adobe_premiere_pro-logo-brandlogos.net.png';
import Filmora from '../assent/filmora_logo.png';
function Skills(){
    return(
        <>
        
<section className="skills" id="skills">
<h2 className="heading">Skills</h2>
<div className="container">
<div className="row" id="skillsContainer">
    <div className="bar">
        <div className="info">
            <img src={HTml} />
            <span>HTml</span>
        </div>
    </div>

    <div className="bar">
        <div className="info">
            <img src={Css} />
            <span>Css</span>
        </div>
    </div>


    <div className="bar">
        <div className="info">
            <img src={Javascript} />
            <span>Javascript</span>
        </div>
    </div>


    <div className="bar">
        <div className="info">
            <img src={Bootstrap} />
            <span>Bootstrap</span>
        </div>
    </div>

    <div className="bar">
        <div className="info">
            <img src={Reacts} />
            <span>React</span>
        </div>
    </div>

    <div className="bar">
        <div className="info">
            <img src={Mterial} />
            <span>Mterial</span>
        </div>
    </div>
    
    <div className="bar">
        <div className="info">
            <img src={PHP}/>
            <span>PHP</span>
        </div>
    </div>
    

    <div className="bar">
        <div className="info">
            <img src={MySQL}/>
            <span>MySQL</span>
        </div>
    </div>
    <div className="bar">
        <div className="info">
            <img src={Wordpress} />
            <span>Wordpress</span>
        </div>
    </div>
    
    <div className="bar">
        <div className="info">
            <img src={Photoshop} />
            <span>Photoshop</span>
        </div>
    </div>
    <div className="bar">
        <div className="info">
            <img src={Figma} />
            <span>Figma</span>
        </div>
    </div>
    <div className="bar">
        <div className="info">
            <img src={Premiere} />
            <span>Premiere</span>
        </div>
    </div>
    <div className="bar">
        <div className="info">
            <img src={Filmora}/>
            <span>Filmora</span>
        </div>
    </div>


    </div>
</div>

</section>

        
        </>
    )
}
export default Skills